import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding, GetFieldValidationResponse } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getOnboardingQueries } from '../../utils/onboarding-queries';
import CardGrid from '../card-grid';
import { CardError, CardSkeleton } from '../card-title';
import orderValidations from './utils/order-validations';
import transformResponse from './utils/transform-response';
import ValidationCard from './validation-card';
type OnboardingFieldValidationsProps = {
  entity: Pick<Entity, 'id' | 'kind'>;
  onboarding: EntityOnboarding;
};
const select = (response: GetFieldValidationResponse) => orderValidations(transformResponse(response));
const OnboardingFieldValidations = t0 => {
  const $ = _c(17);
  const {
    entity,
    onboarding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.validations"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== entity || $[2] !== onboarding) {
    t2 = getOnboardingQueries(entity, onboarding);
    $[1] = entity;
    $[2] = onboarding;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2.matchSignals) {
    t3 = {
      ...t2.matchSignals,
      select
    };
    $[4] = t2.matchSignals;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    error,
    isPending
  } = useQuery(t3);
  if (error && !data) {
    let t4;
    if ($[6] !== error) {
      t4 = <CardError error={error} />;
      $[6] = error;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (isPending) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <CardSkeleton cards={3} rows={1} />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (!data?.length) {
    let t4;
    if ($[9] !== t) {
      t4 = t(_temp);
      $[9] = t;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t4) {
      t5 = <Card.Root><Card.Empty>{t4}</Card.Empty></Card.Root>;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t4;
  if ($[13] !== data) {
    t4 = data.map(_temp2);
    $[13] = data;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <CardGrid>{t4}</CardGrid>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default OnboardingFieldValidations;
function _temp($) {
  return $.empty;
}
function _temp2(validation) {
  return <ValidationCard key={validation.attribute} validation={validation} />;
}